import React, { useState, useEffect, useRef } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const QueryList = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    air: "0",
    ocean: "0",
    truck: "0",
    courier: "0",
  });

  const handleCardClick = (card) => {
    setSelectedCard(selectedCard === card ? null : card);
  };

  const handleSelectChangeAddress = (event, card) => {
    setSelectedOptions({ ...selectedOptions, [card]: event.target.value });
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 32, 
      minHeight: 32,
      display: 'flex',
      alignItems: 'center', 
    }),
    option: (base, state) => ({
      ...base,
      display: 'flex',
      alignItems: 'center', 
      fontSize: '12px',
      fontWeight: "600",
      color: '#808080', 
    }),
    menu: (base) => ({
      ...base,
      fontSize: '12px', 
    }),
    option: (base) => ({
      ...base,
      fontSize: '12px', 
    }),
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">Quote Request Form</h4>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <div className="container">
                <label className="form-label form-label-location">
                  What Shipping method?
                </label>
                <div className="row">
                  <div className="col-md-3">
                    <div className="p-3">
                      <div
                        className={`card service-card service-card-form ${
                          selectedCard === "air" ? "active" : ""
                        }`}
                        onClick={() => handleCardClick("air")}
                      >
                        <div className="card-body card-body-form">
                          <div className="card-content card-content-form">
                            <div className="icon">
                              <svg
                                width={30}
                                height={30}
                                viewBox="0 0 30 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_16_117)">
                                  <path
                                    d="M15 0C13.5244 0 12.5775 1.11 12.0525 2.15812C11.5331 3.2406 11.2591 4.4244 11.25 5.625V12.5456L7.5 14.4206V14.0625C7.5 13.8139 7.40123 13.5754 7.22541 13.3996C7.0496 13.2238 6.81114 13.125 6.5625 13.125H4.6875C4.43886 13.125 4.2004 13.2238 4.02459 13.3996C3.84877 13.5754 3.75 13.8139 3.75 14.0625V16.2956L1.55625 17.3925C1.08869 17.6259 0.695407 17.985 0.420522 18.4295C0.145636 18.8739 1.76532e-05 19.3862 0 19.9088L0 22.5C6.26437e-05 22.6361 0.0297519 22.7705 0.0870054 22.894C0.144259 23.0174 0.227704 23.127 0.331543 23.2149C0.435383 23.3029 0.557128 23.3672 0.68832 23.4033C0.819512 23.4395 0.957006 23.4467 1.09125 23.4244L4.14937 22.9144L4.73625 24.6712C4.79876 24.8575 4.91819 25.0193 5.07765 25.134C5.23712 25.2487 5.42858 25.3104 5.625 25.3104C5.82142 25.3104 6.01288 25.2487 6.17235 25.134C6.33181 25.0193 6.45124 24.8575 6.51375 24.6712L7.27312 22.395L11.4169 21.7031L12.12 25.9275L9.64875 28.3988C9.5173 28.5299 9.42774 28.6971 9.39143 28.8791C9.35512 29.0612 9.37368 29.25 9.44478 29.4215C9.51587 29.593 9.6363 29.7395 9.79078 29.8425C9.94526 29.9455 10.1268 30.0003 10.3125 30H19.6875C19.8732 30.0003 20.0547 29.9455 20.2092 29.8425C20.3637 29.7395 20.4841 29.593 20.5552 29.4215C20.6263 29.25 20.6449 29.0612 20.6086 28.8791C20.5723 28.6971 20.4827 28.5299 20.3512 28.3988L17.88 25.9275L18.5831 21.7031L22.7269 22.395L23.4862 24.6712C23.5488 24.8575 23.6682 25.0193 23.8277 25.134C23.9871 25.2487 24.1786 25.3104 24.375 25.3104C24.5714 25.3104 24.7629 25.2487 24.9223 25.134C25.0818 25.0193 25.2012 24.8575 25.2638 24.6712L25.8506 22.9144L28.9069 23.4244C29.0413 23.447 29.179 23.44 29.3104 23.404C29.4418 23.368 29.5638 23.3037 29.6679 23.2157C29.7719 23.1278 29.8555 23.0181 29.9129 22.8945C29.9703 22.7709 30 22.6363 30 22.5V19.9088C30 19.3862 29.8544 18.8739 29.5795 18.4295C29.3046 17.985 28.9113 17.6259 28.4438 17.3925L26.25 16.2956V14.0625C26.25 13.8139 26.1512 13.5754 25.9754 13.3996C25.7996 13.2238 25.5611 13.125 25.3125 13.125H23.4375C23.1889 13.125 22.9504 13.2238 22.7746 13.3996C22.5988 13.5754 22.5 13.8139 22.5 14.0625V14.4206L18.75 12.5456V5.625C18.75 4.56 18.4875 3.24188 17.9475 2.15812C17.4225 1.10813 16.4756 0 15 0ZM13.125 5.625C13.125 4.815 13.3313 3.78937 13.7288 2.99813C14.1412 2.17313 14.6006 1.875 15 1.875C15.3994 1.875 15.8588 2.17125 16.2713 2.99813C16.6669 3.7875 16.875 4.81687 16.875 5.625V13.125C16.875 13.299 16.9234 13.4695 17.0148 13.6175C17.1062 13.7655 17.237 13.8852 17.3925 13.9631L27.6075 19.0706C27.763 19.1486 27.8938 19.2682 27.9852 19.4162C28.0766 19.5643 28.125 19.7348 28.125 19.9088V21.3937L17.9662 19.7006C17.7214 19.6599 17.4704 19.718 17.2683 19.8621C17.0662 20.0062 16.9294 20.2246 16.8881 20.4694L15.9506 26.0944C15.9258 26.242 15.9367 26.3934 15.9823 26.536C16.028 26.6785 16.1071 26.8081 16.2131 26.9137L17.4244 28.125H12.5756L13.7887 26.9137C13.8945 26.8082 13.9734 26.679 14.0191 26.5368C14.0647 26.3946 14.0758 26.2436 14.0512 26.0963L13.1137 20.4713C13.0935 20.3497 13.0495 20.2333 12.9843 20.1288C12.919 20.0243 12.8338 19.9336 12.7335 19.862C12.6332 19.7905 12.5198 19.7394 12.3997 19.7117C12.2796 19.684 12.1553 19.6802 12.0338 19.7006L1.875 21.3937V19.9088C1.87501 19.7348 1.92341 19.5643 2.01481 19.4162C2.1062 19.2682 2.23697 19.1486 2.3925 19.0706L12.6075 13.9631C12.763 13.8852 12.8938 13.7655 12.9852 13.6175C13.0766 13.4695 13.125 13.299 13.125 13.125V5.625Z"
                                    fill="#E41F07"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_16_117">
                                    <rect width={30} height={30} fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <h5 className="card-title card-title-form">Air</h5>
                          </div>
                        </div>
                        <div className="card-img-overlay p-0">
                          <img
                            src="/assets/img/air-freight.png"
                            alt="Air Freight Image"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="p-3">
                      <div
                        className={`card service-card service-card-form ${
                          selectedCard === "ocean" ? "active" : ""
                        }`}
                        onClick={() => handleCardClick("ocean")}
                      >
                        <div className="card-body card-body-form">
                          <div className="card-content card-content-form">
                            <div className="icon">
                              <svg
                                width={30}
                                height={32}
                                viewBox="0 0 30 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2.4822 23.2691C2.62887 23.6425 2.91597 23.9417 3.28034 24.1007C3.64471 24.2597 4.05652 24.2656 4.42516 24.117C4.7938 23.9684 5.08908 23.6775 5.24604 23.3084C5.403 22.9393 5.40879 22.5221 5.26212 22.1486L3.58819 17.8787L13.5122 15.6529V22.8451C13.5122 23.2467 13.6697 23.6318 13.95 23.9158C14.2303 24.1997 14.6104 24.3592 15.0068 24.3592C15.4032 24.3592 15.7833 24.1997 16.0636 23.9158C16.3439 23.6318 16.5014 23.2467 16.5014 22.8451V15.6529L26.4254 17.8787L24.7515 22.1486C24.6787 22.3335 24.6426 22.5311 24.6452 22.7302C24.6479 22.9292 24.6893 23.1258 24.767 23.3086C24.8448 23.4914 24.9573 23.6569 25.0983 23.7957C25.2392 23.9344 25.4058 24.0436 25.5884 24.117C25.7645 24.1875 25.9521 24.2234 26.1414 24.223C26.4408 24.2233 26.7333 24.1325 26.9811 23.9624C27.2289 23.7923 27.4206 23.5508 27.5314 23.2691L29.848 17.3487C29.9275 17.144 29.962 16.9241 29.9491 16.7044C29.9362 16.4848 29.8762 16.2706 29.7732 16.0768C29.6734 15.8838 29.5335 15.7148 29.3633 15.5816C29.1931 15.4483 28.9964 15.3538 28.7868 15.3046L23.9743 14.2296V7.70357C23.9743 7.302 23.8168 6.91686 23.5365 6.63291C23.2562 6.34895 22.8761 6.18942 22.4797 6.18942H19.4905V1.64696C19.4905 1.24539 19.3331 0.860256 19.0528 0.576297C18.7725 0.292339 18.3923 0.132813 17.996 0.132812H12.0176C11.6212 0.132813 11.2411 0.292339 10.9608 0.576297C10.6805 0.860256 10.523 1.24539 10.523 1.64696V6.18942H7.53389C7.1375 6.18942 6.75735 6.34895 6.47706 6.63291C6.19677 6.91686 6.03931 7.302 6.03931 7.70357V14.2296L1.22676 15.2743C1.01716 15.3235 0.820523 15.418 0.650279 15.5513C0.480036 15.6846 0.340201 15.8535 0.240332 16.0466C0.137399 16.2403 0.0773913 16.4545 0.0644854 16.6741C0.0515796 16.8938 0.0860863 17.1137 0.165603 17.3184L2.4822 23.2691ZM13.5122 3.16112H16.5014V6.18942H13.5122V3.16112ZM9.02847 9.21773H20.9851V13.5482L15.3356 12.246H14.678L9.02847 13.5482V9.21773ZM28.0246 26.2974C27.5002 26.4602 26.9981 26.6891 26.53 26.9787C26.0539 27.2608 25.5123 27.4095 24.9607 27.4095C24.4091 27.4095 23.8675 27.2608 23.3914 26.9787C22.356 26.387 21.1874 26.0761 19.9987 26.0761C18.81 26.0761 17.6413 26.387 16.606 26.9787C16.1233 27.2575 15.5773 27.4042 15.0217 27.4042C14.4661 27.4042 13.9201 27.2575 13.4375 26.9787C12.4012 26.3898 11.233 26.0806 10.0448 26.0806C8.85661 26.0806 7.68836 26.3898 6.65208 26.9787C6.17596 27.2608 5.63433 27.4095 5.08277 27.4095C4.53122 27.4095 3.98959 27.2608 3.51346 26.9787C3.04541 26.6891 2.54328 26.4602 2.01888 26.2974C1.82002 26.2257 1.60843 26.1976 1.39805 26.2148C1.18768 26.232 0.983277 26.2941 0.798312 26.3971C0.613347 26.5001 0.452011 26.6416 0.324925 26.8123C0.197839 26.983 0.107884 27.1791 0.0609827 27.3876C-0.0505943 27.771 -0.00792838 28.1837 0.179671 28.5354C0.36727 28.8872 0.684575 29.1495 1.06235 29.2651C1.36331 29.3477 1.65043 29.4753 1.91426 29.6436C2.82104 30.1827 3.85209 30.4699 4.90342 30.4764C5.99536 30.4766 7.06791 30.1841 8.01215 29.6285C8.59799 29.3011 9.25615 29.1294 9.92522 29.1294C10.5943 29.1294 11.2524 29.3011 11.8383 29.6285C12.7758 30.1716 13.8371 30.4573 14.9171 30.4573C15.9971 30.4573 17.0584 30.1716 17.996 29.6285C18.5818 29.3011 19.24 29.1294 19.909 29.1294C20.5781 29.1294 21.2362 29.3011 21.8221 29.6285C22.7484 30.1886 23.8072 30.4844 24.886 30.4844C25.9648 30.4844 27.0235 30.1886 27.9499 29.6285C28.2137 29.4601 28.5008 29.3326 28.8018 29.25C29.0007 29.2092 29.1893 29.1278 29.3561 29.0108C29.523 28.8938 29.6646 28.7436 29.7722 28.5693C29.8799 28.3951 29.9514 28.2004 29.9824 27.9972C30.0135 27.7941 30.0033 27.5866 29.9526 27.3876C29.9051 27.1826 29.816 26.99 29.6908 26.822C29.5657 26.6539 29.4074 26.5141 29.226 26.4115C29.0446 26.3089 28.844 26.2458 28.6372 26.2262C28.4303 26.2065 28.2217 26.2307 28.0246 26.2974Z"
                                  fill="#E41F07"
                                />
                              </svg>
                            </div>
                            <h5 className="card-title card-title-form">
                              Ocean
                            </h5>
                          </div>
                        </div>
                        <div className="card-img-overlay p-0">
                          <img
                            src="/assets/img/sea.png"
                            alt="Sea Freight Image"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="p-3">
                      <div
                        className={`card service-card service-card-form ${
                          selectedCard === "truck" ? "active" : ""
                        }`}
                        onClick={() => handleCardClick("truck")}
                      >
                        <div className="card-body card-body-form">
                          <div className="card-content card-content-form">
                            <div className="icon">
                              <svg
                                width={45}
                                height={30}
                                viewBox="0 0 48 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.60669 0.132812V14.3766C2.1111 14.5845 2.54159 14.946 2.88 15.3454C3.40599 15.9661 3.78718 16.6971 4.13503 17.381C4.48288 18.0649 4.7988 18.7073 5.07324 19.1045C5.34798 19.5018 5.48465 19.5489 5.52301 19.5489C5.58226 19.5489 5.60134 19.5573 5.76 19.348C5.91896 19.1386 6.11849 18.7449 6.33068 18.2986C6.54286 17.8522 6.7681 17.3532 7.11716 16.893C7.46621 16.4328 8.03819 15.978 8.7364 15.978C9.43461 15.978 10.0067 16.4327 10.3556 16.893C10.7047 17.3531 10.9298 17.8521 11.1421 18.2984C11.3544 18.7448 11.5538 19.1385 11.7127 19.3478C11.8714 19.557 11.8904 19.5487 11.9497 19.5487C12.0089 19.5487 12.028 19.557 12.1867 19.3478C12.3456 19.1384 12.5452 18.7447 12.7574 18.2983C12.9695 17.852 13.1948 17.353 13.5438 16.8928C13.8929 16.4326 14.4649 15.9778 15.1631 15.9778C15.8613 15.9778 16.4334 16.4325 16.7823 16.8928C17.1314 17.3529 17.3565 17.8519 17.5688 18.2982C17.7811 18.7446 17.9805 19.1383 18.1394 19.3476C18.298 19.5568 18.3171 19.5484 18.3764 19.5484C18.4356 19.5484 18.4547 19.5568 18.6134 19.3476C18.7723 19.1381 18.9718 18.7445 19.184 18.2981C19.3962 17.8518 19.6215 17.3528 19.9705 16.8926C20.3196 16.4324 20.8915 15.9776 21.5898 15.9776C22.288 15.9776 22.8601 16.4323 23.209 16.8926C23.5581 17.3526 23.7832 17.8517 23.9955 18.298C24.2078 18.7443 24.4072 19.138 24.5661 19.3474C24.7247 19.5566 24.7438 19.5482 24.803 19.5482C24.8623 19.5482 24.8814 19.5566 25.04 19.3474C25.199 19.1379 25.3985 18.7442 25.6107 18.2979C25.8229 17.8515 26.0481 17.3525 26.3972 16.8923C26.7462 16.4322 27.3182 15.9773 28.0164 15.9773C28.7146 15.9773 29.2664 16.3456 29.7261 16.7589C29.9412 16.9523 30.1403 17.1648 30.3261 17.3857V0.132812H1.60669ZM33.7406 5.64263V21.2949L34.5439 21.292V23.1197H34.9265C35.8602 21.0091 37.816 19.5489 40.0669 19.5489C42.0214 19.5489 43.753 20.6499 44.7866 22.3214V15.9781H46.3933V11.9303L43.5559 7.20071L33.7406 5.64263ZM35.6026 7.82035L42.1067 8.68247L44.5971 12.6449V14.5123H35.6026V7.82035ZM1.60669 16.7757V19.5489H3.1669C2.95401 19.1591 2.75869 18.7571 2.56137 18.3692C2.24274 17.7424 1.91869 17.161 1.60669 16.7757ZM8.7364 17.9867C8.67715 17.9867 8.65808 17.9783 8.49941 18.1875C8.34045 18.397 8.14092 18.7907 7.92874 19.237C7.88054 19.3385 7.83113 19.4431 7.78032 19.5489H9.69228C9.64157 19.4431 9.59217 19.3384 9.54397 19.237C9.33168 18.7907 9.13225 18.397 8.97339 18.1876C8.81473 17.9784 8.79565 17.9867 8.7364 17.9867ZM15.1632 17.9867C15.1039 17.9867 15.0849 17.9783 14.9262 18.1875C14.7672 18.397 14.5677 18.7907 14.3555 19.237C14.3073 19.3385 14.2579 19.4431 14.2071 19.5489H16.1191C16.0684 19.4431 16.0189 19.3384 15.9707 19.237C15.7585 18.7907 15.559 18.397 15.4002 18.1876C15.2415 17.9784 15.2224 17.9867 15.1632 17.9867ZM21.59 17.9867C21.5307 17.9867 21.5116 17.9783 21.353 18.1875C21.194 18.397 20.9945 18.7907 20.7823 19.237C20.7341 19.3385 20.6847 19.4431 20.6339 19.5489H22.5458C22.4951 19.4431 22.4457 19.3384 22.3975 19.237C22.1852 18.7907 21.9858 18.397 21.8269 18.1876C21.6683 17.9784 21.6492 17.9867 21.59 17.9867ZM28.0167 17.9867C27.9575 17.9867 27.9384 17.9783 27.7798 18.1875C27.6208 18.397 27.4213 18.7907 27.2091 19.237C27.1609 19.3385 27.1115 19.4431 27.0607 19.5489H29.5869C29.5491 19.4918 29.5126 19.4348 29.4734 19.3776C29.1935 18.9708 28.8742 18.5772 28.5893 18.3209C28.3045 18.0648 28.076 17.9867 28.0167 17.9867ZM46.5941 17.9867V23.1197H48V17.9867H46.5941ZM5.52301 21.3343C3.25988 21.3343 1.40586 23.3945 1.40586 25.9093C1.40586 28.4242 3.25988 30.4844 5.52301 30.4844C7.78614 30.4844 9.64017 28.4242 9.64017 25.9093C9.64017 23.3945 7.78614 21.3343 5.52301 21.3343ZM15.9665 21.3343C13.7034 21.3343 11.8494 23.3945 11.8494 25.9093C11.8494 28.4242 13.7034 30.4844 15.9665 30.4844C18.2297 30.4844 20.0837 28.4242 20.0837 25.9093C20.0837 23.3945 18.2297 21.3343 15.9665 21.3343ZM40.0669 21.3343C37.8038 21.3343 35.9498 23.3945 35.9498 25.9093C35.9498 28.4242 37.8038 30.4844 40.0669 30.4844C42.3301 30.4844 44.1841 28.4242 44.1841 25.9093C44.1841 23.3945 42.3301 21.3343 40.0669 21.3343ZM0 21.5574V23.1197H0.382594C0.636177 22.5478 0.965159 22.0213 1.35866 21.5574H0ZM9.68736 21.5574C10.0809 22.0213 10.4098 22.5478 10.6634 23.1197H10.8261C11.0797 22.5478 11.4087 22.0213 11.8022 21.5574H9.68736ZM20.1309 21.5574C20.5244 22.0213 20.8534 22.5478 21.1069 23.1197H21.4895V21.5574H20.1309ZM32.7364 23.3069L23.2971 23.3398V26.6874L32.7364 26.6545V23.3069ZM5.52301 23.3428C6.80937 23.3428 7.83264 24.4799 7.83264 25.9093C7.83264 27.3387 6.80937 28.4758 5.52301 28.4758C4.23665 28.4758 3.21339 27.3387 3.21339 25.9093C3.21339 24.4799 4.23665 23.3428 5.52301 23.3428ZM15.9665 23.3428C17.2529 23.3428 18.2762 24.4799 18.2762 25.9093C18.2762 27.3387 17.2529 28.4758 15.9665 28.4758C14.6802 28.4758 13.6569 27.3387 13.6569 25.9093C13.6569 24.4799 14.6802 23.3428 15.9665 23.3428ZM40.0669 23.3428C41.3533 23.3428 42.3766 24.4799 42.3766 25.9093C42.3766 27.3387 41.3533 28.4758 40.0669 28.4758C38.7806 28.4758 37.7573 27.3387 37.7573 25.9093C37.7573 24.4799 38.7806 23.3428 40.0669 23.3428Z"
                                  fill="#E41F07"
                                />
                              </svg>
                            </div>
                            <h5 className="card-title card-title-form">
                              Truck
                            </h5>
                          </div>
                        </div>
                        <div className="card-img-overlay p-0">
                          <img
                            src="/assets/img/cargo.png"
                            alt="Cargo Freight Image"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="p-3">
                      <div
                        className={`card service-card service-card-form ${
                          selectedCard === "courier" ? "active" : ""
                        }`}
                        onClick={() => handleCardClick("courier")}
                      >
                        <div className="card-body card-body-form">
                          <div className="card-content card-content-form">
                            <div className="icon">
                              <svg
                                width="30"
                                height="30"
                                viewBox="0 0 512 512"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M137.965 199.539C141.152 200.261 142.144 201.297 144 204C144.514 207.227 144.454 210.426 144.438 213.688C144.641 221.37 144.932 226.916 150 233C151.218 234.533 151.218 234.533 152.461 236.098C160.651 246.199 169.775 256.183 180.432 263.72C183.38 266.337 184.468 268.476 186.008 272.086C186.52 273.264 187.032 274.442 187.559 275.656C188.082 276.896 188.604 278.135 189.125 279.375C189.654 280.607 190.184 281.839 190.715 283.07C191.696 285.345 192.671 287.623 193.638 289.904C194.996 292.99 196.467 295.997 198 299C198.277 297.871 198.554 296.742 198.839 295.579C199.88 291.345 200.937 287.115 201.998 282.887C202.453 281.065 202.904 279.241 203.351 277.417C205.718 267.756 207.952 258.668 213 250C215.266 244.676 216.648 238.79 216 233C214.458 230.492 212.805 228.669 210.664 226.656C207.847 223.852 207.796 220.856 207.688 217.062C207.741 213.761 207.838 212.283 209.5 209.375C213.035 207.431 216.056 207.182 220 208C222.969 210.207 223.829 211.486 225 215C226.73 216.172 226.73 216.172 228.938 217.117C229.797 217.518 230.656 217.919 231.542 218.331C232.5 218.767 233.458 219.203 234.446 219.652C236.561 220.64 238.676 221.63 240.79 222.621C241.947 223.16 243.104 223.7 244.296 224.257C254.678 229.125 264.956 234.215 275.237 239.292C278.947 241.124 282.662 242.947 286.387 244.751C290.067 246.533 293.736 248.338 297.398 250.158C298.771 250.835 300.148 251.506 301.529 252.167C310.411 256.433 316.869 261.093 323 269C323.544 269.626 324.087 270.252 324.647 270.898C327.098 273.887 328.338 276.372 328.563 280.188C328 284 328 284 326.5 286.5C323.01 288.594 319.904 288.874 316 288C313.233 285.871 311.48 283.659 309.434 280.846C302.435 272.016 293.435 268.089 283.438 263.375C281.743 262.555 280.05 261.734 278.358 260.91C274.25 258.916 270.129 256.95 266 255C265.954 255.723 265.907 256.446 265.858 257.191C265.005 268.463 261.174 278.143 254 287C250.696 288.652 247.544 288.765 244 288C241.793 286.499 239.993 284.807 238.078 282.949C233.374 278.536 228.03 275.249 222 273C221.893 274.077 221.786 275.153 221.675 276.263C220.969 281.881 219.577 287.311 218.2 292.797C217.922 293.908 217.644 295.019 217.358 296.164C216.772 298.501 216.182 300.838 215.59 303.173C214.688 306.749 213.806 310.329 212.924 313.91C212.351 316.185 211.776 318.46 211.2 320.734C210.939 321.804 210.678 322.874 210.41 323.976C210.153 324.971 209.896 325.966 209.632 326.991C209.303 328.301 209.303 328.301 208.968 329.637C207.801 332.488 206.334 334.016 204 336C202 336.531 202 336.531 200 336.5C199.01 336.515 199.01 336.515 198 336.531C195.129 335.769 193.96 334.204 192 332C190.722 329.659 190.722 329.659 189.618 327.048C189.198 326.067 188.778 325.086 188.345 324.076C187.907 323.025 187.468 321.974 187.016 320.891C186.556 319.809 186.095 318.727 185.621 317.612C184.155 314.162 182.702 310.706 181.25 307.25C180.258 304.907 179.264 302.565 178.27 300.223C175.836 294.486 173.414 288.745 171 283C162.227 283 155.245 289.365 149 295C147.041 297.089 145.183 299.213 143.375 301.434C141.049 304.084 139.822 304.015 136.188 304.312C133.153 304.483 132.09 304.06 129.516 302.324C115.115 289.019 104.347 269.533 94.0003 253C89.6365 253.94 86.1173 256.054 82.3128 258.312C81.5682 258.753 80.8237 259.194 80.0565 259.648C67.6697 267.098 55.9584 275.575 45.0003 285C44.1392 285.715 43.2782 286.431 42.391 287.168C35.7812 292.826 28.8113 299.567 26.0003 308C23.9179 346.485 33.6947 385.807 46.0003 422C73.4151 417.659 104.895 409.487 125 389C124.737 388.404 124.474 387.808 124.203 387.194C121.46 380.971 118.738 374.741 116.028 368.504C115.015 366.18 113.996 363.858 112.973 361.539C111.499 358.198 110.045 354.85 108.594 351.5C107.905 349.954 107.905 349.954 107.202 348.377C104.736 342.626 103.306 338.27 104 332C105.5 329.5 105.5 329.5 108 328C110.78 327.453 113.252 327.27 116 328C119.157 330.747 120.865 333.331 122.534 337.145C122.988 338.17 123.441 339.195 123.909 340.252C124.385 341.356 124.861 342.46 125.352 343.598C125.852 344.742 126.352 345.887 126.867 347.066C127.923 349.489 128.974 351.914 130.019 354.342C131.084 356.814 132.158 359.282 133.243 361.746C134.812 365.316 136.366 368.893 137.914 372.473C138.635 374.108 138.635 374.108 139.37 375.776C141.913 381.729 143.673 387.231 144.497 393.665C145.361 397.676 147.77 400.184 150.563 403.062C151.362 403.938 151.362 403.938 152.178 404.831C153.255 406.008 154.342 407.178 155.437 408.338C156.892 409.885 158.314 411.455 159.723 413.043C162.426 416.088 165.121 419.12 168 422C178.34 422.369 189.308 419.718 199.52 418.164C201.392 417.881 203.263 417.598 205.135 417.316C209.036 416.725 212.937 416.131 216.837 415.535C221.823 414.774 226.811 414.025 231.799 413.28C235.657 412.701 239.512 412.114 243.368 411.524C245.207 411.244 247.046 410.968 248.885 410.694C251.456 410.311 254.025 409.916 256.593 409.518C257.344 409.409 258.095 409.3 258.868 409.187C265.48 408.14 271.065 406.086 276.34 401.82C277.094 401.221 277.847 400.621 278.623 400.004C279.387 399.384 280.151 398.764 280.938 398.125C292.027 389.19 300.072 383.697 314.657 383.664C316.187 383.654 316.187 383.654 317.749 383.644C319.901 383.634 322.052 383.629 324.204 383.629C327.489 383.625 330.774 383.589 334.059 383.551C336.154 383.545 338.249 383.541 340.344 383.539C341.322 383.525 342.301 383.51 343.309 383.496C349.199 383.535 352.501 384.106 357 388C361.088 393.252 360.616 398.625 360 405C358.285 410.449 354.835 414.074 350 417C343.195 419.653 336.073 421.233 329 423C330.127 423.005 330.127 423.005 331.276 423.011C338.367 423.049 345.458 423.106 352.55 423.184C356.195 423.223 359.84 423.256 363.486 423.271C367.007 423.286 370.527 423.321 374.048 423.368C376.039 423.39 378.029 423.392 380.02 423.394C388.582 423.533 392.38 424.285 398.375 430.438C401.221 436.676 401.12 443.275 399.153 449.82C395.847 457.149 390.926 462.246 383.59 465.523C366.188 471.657 346.471 472.496 328.188 472.562C327.41 472.571 326.632 472.579 325.831 472.588C317.163 472.656 309.173 472.02 300.739 469.965C284.044 466.009 272.718 469.196 256.834 475.008C252.217 476.697 247.582 478.334 242.947 479.976C239.469 481.209 235.993 482.45 232.516 483.691C158.467 510.029 158.467 510.029 137.563 501.938C135.685 501.004 133.83 500.024 132 499C131.031 498.492 130.062 497.984 129.063 497.461C118.182 491.482 108.603 483.706 99.5121 475.301C98.1386 474.043 96.7574 472.792 95.3417 471.582C89.5533 466.631 84.1607 461.313 78.7899 455.92C77.2427 454.367 75.6901 452.82 74.1371 451.273C73.138 450.274 72.1393 449.274 71.141 448.273C70.2493 447.381 69.3576 446.488 68.4388 445.568C66.1363 443.143 64.0451 440.644 62.0003 438C60.8189 438.217 60.8189 438.217 59.6136 438.438C43.3181 441.214 43.3181 441.214 36.0003 440C32.191 436.955 30.9397 433.835 29.4144 429.27C29.192 428.611 28.9697 427.952 28.7406 427.274C28.0211 425.124 27.3216 422.969 26.6253 420.812C26.3829 420.072 26.1405 419.331 25.8907 418.568C15.1993 385.844 8.14275 351.435 7.62534 316.938C7.59916 315.902 7.57298 314.867 7.546 313.8C7.51282 298.587 15.8178 287.952 26.1253 277.5C43.8501 260.066 65.439 246.947 86.9525 234.747C96.8202 229.149 106.512 223.286 116.191 217.369C117.314 216.683 118.437 215.996 119.594 215.289C120.591 214.678 121.588 214.066 122.616 213.436C125 212 125 212 127 211C127.601 208.726 127.957 206.449 128.34 204.129C129.797 199.432 133.695 199.72 137.965 199.539ZM122.868 233.406C122.062 233.903 121.256 234.399 120.426 234.91C119.584 235.435 118.743 235.959 117.875 236.5C117.026 237.025 116.176 237.549 115.301 238.09C113.198 239.389 111.098 240.693 109 242C109.611 245.015 110.556 247.146 112.266 249.695C112.738 250.403 113.21 251.111 113.696 251.84C114.209 252.594 114.722 253.348 115.25 254.125C115.778 254.906 116.306 255.687 116.85 256.492C118.556 259.002 120.276 261.502 122 264C122.592 264.859 123.183 265.717 123.792 266.602C125.535 269.119 127.295 271.624 129.063 274.125C129.884 275.307 129.884 275.307 130.722 276.512C131.238 277.233 131.754 277.953 132.285 278.695C132.738 279.335 133.191 279.974 133.657 280.633C134.1 281.084 134.544 281.535 135 282C138.839 282 139.317 281.009 142 278.375C146.855 273.88 152.094 270.915 158 268C154.445 263.676 150.729 259.751 146.688 255.875C139.273 248.649 133.476 240.356 129 231C126.336 231 125.129 232.005 122.868 233.406ZM233 238C232.485 240.557 231.969 243.115 231.438 245.75C231.189 246.948 231.189 246.948 230.936 248.171C230.236 251.773 229.741 254.53 231 258C233.166 259.47 233.166 259.47 235.813 260.562C238.504 261.775 240.836 262.876 243.2 264.652C244.892 266.2 244.892 266.2 247 266C249.485 259.324 249.147 253.089 249 246C243.72 243.36 238.44 240.72 233 238ZM292.375 410.938C290.551 412.365 288.726 413.791 286.899 415.215C286.101 415.845 285.304 416.475 284.482 417.125C279.283 421.053 275.374 423.481 268.859 424.554C268.168 424.671 267.478 424.789 266.767 424.91C264.514 425.288 262.258 425.645 260 426C258.459 426.252 256.918 426.504 255.376 426.757C250.343 427.576 245.305 428.359 240.266 429.137C239.358 429.277 238.45 429.418 237.514 429.563C232.722 430.305 227.93 431.044 223.137 431.781C218.225 432.536 213.315 433.302 208.405 434.07C204.588 434.666 200.77 435.253 196.951 435.838C195.141 436.117 193.331 436.399 191.522 436.684C166.346 440.642 166.346 440.642 159.563 437.312C156.939 434.945 154.443 432.556 152 430C151.365 429.397 150.729 428.793 150.075 428.172C143.301 421.675 137.67 414.45 132 407C130.983 407.654 130.983 407.654 129.946 408.32C127.981 409.578 126.012 410.828 124.039 412.074C122.253 413.206 120.473 414.35 118.711 415.52C107.263 422.862 93.8195 427.621 81.0003 432C87.9812 442.266 97.3669 451.191 106.84 459.176C108.609 460.669 110.341 462.189 112.067 463.73C130.375 480.068 130.375 480.068 153 488C182.405 485.926 212.32 472.673 239.907 463.184C240.906 462.841 241.905 462.498 242.934 462.145C248.079 460.373 253.209 458.57 258.326 456.718C259.355 456.35 260.384 455.981 261.445 455.601C263.387 454.904 265.326 454.198 267.262 453.481C279.381 449.151 290.211 450.247 302.563 452.938C321.682 457.064 339.538 456.211 358.75 453.312C359.619 453.185 360.488 453.057 361.384 452.925C363.879 452.55 366.37 452.15 368.86 451.738C369.982 451.568 369.982 451.568 371.126 451.393C375.743 450.583 378.823 449.506 382 446C382.398 444.012 382.739 442.011 383 440C382.21 439.994 381.419 439.988 380.604 439.982C373.145 439.924 365.685 439.852 358.226 439.764C354.391 439.72 350.556 439.68 346.721 439.654C343.019 439.628 339.317 439.587 335.614 439.537C334.203 439.52 332.793 439.509 331.382 439.502C329.402 439.493 327.422 439.463 325.443 439.432C324.317 439.421 323.191 439.41 322.031 439.399C317.564 438.811 314.974 436.92 311.75 433.875C309.01 429.372 308.442 425.002 309.407 419.816C310.957 414.934 313.409 411.431 318 409C323.315 407.006 328.765 405.58 334.254 404.156C335.737 403.77 335.737 403.77 337.25 403.375C338.588 403.046 338.588 403.046 339.953 402.711C342.191 402.201 342.191 402.201 343 400C338.59 399.925 334.179 399.871 329.768 399.835C328.27 399.82 326.773 399.8 325.276 399.774C310.859 399.529 303.775 401.894 292.375 410.938Z"
                                  fill="#E41F07"
                                />
                                <path
                                  d="M246.476 303.492C247.555 303.486 248.633 303.48 249.745 303.473C253.372 303.457 256.998 303.47 260.625 303.482C263.22 303.477 265.815 303.47 268.41 303.461C274.734 303.443 281.058 303.447 287.382 303.459C292.521 303.468 297.66 303.469 302.799 303.465C303.896 303.464 303.896 303.464 305.014 303.463C306.499 303.462 307.984 303.46 309.469 303.459C323.399 303.448 337.328 303.461 351.257 303.482C363.213 303.5 375.169 303.497 387.125 303.479C401.003 303.457 414.882 303.449 428.761 303.461C430.241 303.462 431.72 303.464 433.2 303.465C434.292 303.466 434.292 303.466 435.406 303.467C440.54 303.47 445.673 303.464 450.807 303.455C457.715 303.442 464.623 303.451 471.53 303.474C474.07 303.48 476.61 303.478 479.149 303.469C482.608 303.459 486.065 303.472 489.523 303.492C491.042 303.479 491.042 303.479 492.592 303.465C499.29 303.541 499.29 303.541 502.623 305.7C504.277 308.463 504.502 310.1 504.507 313.314C504.524 314.929 504.524 314.929 504.542 316.576C504.53 318.341 504.53 318.341 504.517 320.141C504.528 322.005 504.528 322.005 504.538 323.906C504.553 327.311 504.55 330.716 504.537 334.121C504.527 337.685 504.536 341.249 504.542 344.814C504.55 350.799 504.54 356.784 504.521 362.77C504.499 369.688 504.506 376.607 504.528 383.526C504.546 389.467 504.549 395.409 504.539 401.35C504.532 404.898 504.531 408.446 504.545 411.994C504.558 415.95 504.539 419.904 504.517 423.859C504.525 425.036 504.533 426.212 504.542 427.424C504.53 428.5 504.519 429.577 504.507 430.687C504.505 432.089 504.505 432.089 504.503 433.52C503.84 436.784 502.601 437.978 500 440C497.286 440.395 494.977 440.548 492.265 440.518C491.491 440.525 490.716 440.532 489.918 440.539C487.362 440.556 484.806 440.545 482.25 440.531C480.471 440.534 478.693 440.538 476.915 440.543C473.189 440.549 469.464 440.54 465.738 440.522C460.963 440.499 456.188 440.512 451.413 440.536C447.741 440.55 444.07 440.546 440.398 440.535C438.637 440.533 436.877 440.536 435.116 440.545C432.655 440.555 430.195 440.54 427.734 440.518C427.007 440.526 426.279 440.534 425.53 440.542C422.086 440.484 420.303 440.236 417.549 438.093C415.868 435.822 415.456 434.79 415.5 432C415.484 431.01 415.484 431.01 415.468 430C416.255 427.038 417.616 425.902 420 424C423.062 423.519 423.062 423.519 426.696 423.546C427.36 423.545 428.023 423.545 428.707 423.544C430.894 423.547 433.079 423.578 435.265 423.609C436.784 423.617 438.303 423.623 439.822 423.627C443.814 423.642 447.805 423.681 451.796 423.725C455.872 423.766 459.947 423.785 464.023 423.805C472.015 423.848 480.007 423.918 488 424C488 416.08 488 408.16 488 400C463.58 400 439.16 400 414 400C413.01 401.98 413.01 401.98 412 404C408.139 407.658 405.313 408.315 400 408.5C394.686 408.315 391.861 407.658 388 404C387.295 402.686 386.62 401.355 386 400C385.035 400.046 384.071 400.093 383.078 400.141C381.814 400.177 380.551 400.213 379.25 400.25C377.997 400.296 376.744 400.343 375.453 400.391C372 400 372 400 369.578 398.234C367.917 395.883 367.455 394.836 367.5 392C367.484 391.01 367.484 391.01 367.468 390C368.305 386.848 369.312 385.922 372 384C375.695 383.399 379.366 383.496 383.102 383.546C384.234 383.545 385.366 383.545 386.532 383.544C390.277 383.547 394.021 383.578 397.765 383.609C400.36 383.617 402.955 383.623 405.55 383.627C411.684 383.64 417.818 383.672 423.952 383.712C430.936 383.757 437.92 383.779 444.905 383.799C459.27 383.841 473.635 383.914 488 384C488 376.08 488 368.16 488 360C463.58 360 439.16 360 414 360C413.34 361.32 412.68 362.64 412 364C408.139 367.658 405.313 368.315 400 368.5C394.686 368.315 391.861 367.658 388 364C387.01 362.02 387.01 362.02 386 360C358.94 360 331.88 360 304 360C304 363.96 304 367.92 304 372C300 376 300 376 298 376.531C297.34 376.521 296.68 376.511 296 376.5C295.01 376.516 295.01 376.516 294 376.531C292 376 292 376 288 372C288 368.04 288 364.08 288 360C274.8 360 261.6 360 248 360C248 367.92 248 375.84 248 384C254.402 383.842 254.402 383.842 260.803 383.64C267.347 383.558 267.347 383.558 270.609 385.766C272.059 388.096 272.542 389.283 272.5 392C272.51 392.66 272.52 393.32 272.531 394C271.698 397.137 270.695 398.149 268 400C263.783 400.678 259.525 400.507 255.265 400.488C250.003 400.425 250.003 400.425 245.625 403C245.088 403.66 244.552 404.32 244 405C242 405.531 242 405.531 240 405.5C239.34 405.51 238.68 405.521 238 405.531C234.949 404.721 233.908 403.526 232 401C231.398 398.028 231.453 395.096 231.482 392.072C231.475 391.171 231.468 390.27 231.461 389.341C231.443 386.363 231.455 383.385 231.468 380.406C231.466 378.337 231.462 376.267 231.457 374.197C231.451 369.859 231.459 365.522 231.478 361.184C231.501 355.622 231.488 350.061 231.464 344.498C231.449 340.224 231.454 335.951 231.464 331.677C231.467 329.626 231.464 327.575 231.454 325.524C231.444 322.658 231.46 319.794 231.482 316.928C231.474 316.079 231.466 315.23 231.457 314.355C231.469 313.573 231.48 312.791 231.492 311.985C231.493 311.308 231.495 310.631 231.496 309.933C233.437 302.478 240.191 303.437 246.476 303.492ZM248 320C248 327.92 248 335.84 248 344C261.2 344 274.4 344 288 344C288 336.08 288 328.16 288 320C274.8 320 261.6 320 248 320ZM304 320C304 327.92 304 335.84 304 344C364.72 344 425.44 344 488 344C488 336.08 488 328.16 488 320C478.42 319.887 468.841 319.795 459.262 319.741C454.813 319.715 450.366 319.679 445.918 319.623C441.625 319.569 437.333 319.539 433.041 319.526C431.403 319.516 429.765 319.498 428.127 319.471C425.833 319.435 423.541 319.43 421.247 319.432C419.941 319.421 418.635 319.41 417.29 319.399C413.828 319.698 413.828 319.698 411.664 322.455C411.115 323.295 410.566 324.135 410 325C405.307 328.213 399.436 327.603 394 327C390.225 325.538 388.251 323.377 386 320C383.337 319.714 380.908 319.622 378.245 319.659C377.445 319.659 376.645 319.659 375.821 319.658C373.169 319.66 370.518 319.684 367.867 319.707C366.031 319.713 364.196 319.717 362.36 319.72C357.523 319.731 352.687 319.761 347.85 319.794C342.917 319.825 337.984 319.838 333.05 319.854C323.367 319.886 313.683 319.939 304 320Z"
                                  fill="#E41F07"
                                />
                                <path
                                  d="M180.824 7.60889C183.264 7.62509 185.702 7.60886 188.141 7.58985C200.704 7.57108 212.916 8.61451 224.25 14.5625C224.919 14.9098 225.588 15.2571 226.278 15.615C243.277 24.8888 250.775 42.2892 257.371 59.5664C257.664 60.3309 257.957 61.0954 258.258 61.8831C259 64 259 64 259.778 67.4062C260.831 70.3228 260.831 70.3228 264.196 71.6523C265.5 72.0979 266.81 72.5255 268.125 72.9375C274.567 75.2352 279.45 77.7132 284 83C284.675 83.7812 284.675 83.7812 285.364 84.5781C289.031 89.7705 288.832 95.8982 288 102C285.735 106.88 282.846 109.667 278 112C273.374 112.717 269.496 112.855 265.375 110.5C263.431 106.965 263.184 103.945 264 100C265.813 97.5 265.813 97.5 268 96C268.99 96 269.98 96 271 96C266.153 90.8063 262.086 89.2725 255 89C236.041 89.1264 220.033 92.7429 206.159 106.166C201.471 110.688 198.66 112.251 192.121 112.24C190.936 112.243 189.75 112.247 188.529 112.251C187.25 112.247 185.971 112.243 184.653 112.238C183.317 112.244 181.981 112.252 180.646 112.261C174.988 112.298 169.33 112.317 163.672 112.305C160.205 112.3 156.738 112.318 153.271 112.351C151.329 112.363 149.387 112.348 147.444 112.332C139.099 112.423 133.341 114.146 126 118C122.555 119.074 122.555 119.074 119.875 119.688C117.206 120.264 117.206 120.264 115 121C112.777 125.447 113.495 131.173 114 136C115.379 139.382 117.511 141.337 120.903 142.847C121.574 143.122 122.246 143.397 122.938 143.68C127.644 145.984 129.055 148.856 131 153.562C131.662 155.006 132.331 156.446 133.008 157.883C133.338 158.586 133.669 159.289 134.009 160.013C141.611 175.253 154.033 183.667 169.625 189.312C183.894 192.219 195.408 190.48 208 183C225.971 170.904 232.777 145.466 236.761 125.362C237.907 119.182 238.416 113.152 238.727 106.875C239.096 102.995 240.049 100.357 242 97C245.13 95.4353 248.611 95.303 252 96C254.223 97.4766 254.223 97.4766 256 100C256.445 103.053 256.617 105.636 256.563 108.688C256.553 109.558 256.542 110.429 256.532 111.326C255.687 138.533 246.436 168.504 228 189C227.449 189.633 226.897 190.266 226.328 190.918C217.795 200.121 205.112 207.369 192.42 208.161C169.668 208.51 151.327 205.383 133.813 189.82C126.543 182.53 120.633 174.893 116.375 165.5C113.768 159.886 111.503 157.33 106.149 154.352C100.673 150.907 97.4927 145.156 96.0003 139C95.7909 135.1 95.8574 131.216 95.9378 127.312C95.9722 125.246 96.0023 123.18 96.0276 121.113C96.0456 120.204 96.0635 119.294 96.0821 118.357C96.1063 115.846 96.1063 115.846 95.0003 113C91.4616 87.2323 92.0062 57.8292 107 35.6289C120.648 17.689 139.996 11.225 161.531 8.27759C167.943 7.55668 174.379 7.55813 180.824 7.60889ZM157 36C149.696 45.1181 145.983 53.7529 143.809 65.1797C142.973 68.0934 142.478 69.2978 140 71C138.063 71.3984 138.063 71.3984 136 71.375C134.979 71.3866 134.979 71.3866 133.938 71.3984C131.378 70.872 130.519 70.1172 129 68C126.668 55.9413 132.848 43.5368 138 33C129.167 35.478 123.02 41.5976 118.563 49.5C112.295 62.2292 110.653 75.0222 110.813 89.125C110.813 90.2465 110.814 91.368 110.815 92.5234C110.592 97.9322 110.592 97.9322 112 103C128.449 100.655 137.937 91.2379 149.063 79.8125C164.475 64.3022 183.008 56.7462 204.688 56.375C215.852 56.3617 225.765 58.8164 236.226 62.5627C238.09 63.2254 238.09 63.2254 240 62C230.962 41.2522 230.962 41.2522 213.093 28.217C207.155 26.0481 201.403 25.2957 195.125 24.8125C194.189 24.7306 193.254 24.6488 192.289 24.5645C177.801 23.3258 167.805 25.4354 157 36ZM169 84C165.109 87.4393 161.465 91.1336 158 95C158 95.33 158 95.66 158 96C162.677 96.2243 167.351 96.3866 172.032 96.4944C173.62 96.5394 175.208 96.6006 176.795 96.679C186.254 97.3322 186.254 97.3322 194.876 94.1104C197.087 91.8421 199.031 89.4774 201 87C207.108 82.0064 214.502 78.3523 222 76C207.142 66.0946 181.935 74.3287 169 84Z"
                                  fill="#E41F07"
                                />
                                <path
                                  d="M64.0001 455.5C64.6601 455.49 65.3201 455.479 66.0001 455.469C69.0538 456.28 70.0912 457.47 72.0001 460C72.6013 462.997 72.5607 465.951 72.5314 469C72.5352 469.873 72.539 470.745 72.543 471.645C72.5457 473.487 72.5383 475.329 72.5216 477.172C72.5002 479.99 72.5214 482.806 72.547 485.625C72.5444 487.417 72.5392 489.208 72.5314 491C72.5395 491.842 72.5476 492.684 72.5559 493.551C72.4625 499.387 72.4625 499.387 70.0919 502.529C67.8274 504.121 66.7391 504.543 64.0001 504.5C63.0101 504.515 63.0101 504.515 62.0001 504.531C58.9464 503.72 57.909 502.53 56.0001 500C55.399 497.003 55.4395 494.049 55.4689 491C55.465 490.127 55.4612 489.255 55.4573 488.355C55.4546 486.513 55.4619 484.671 55.4786 482.828C55.5 480.01 55.4788 477.194 55.4532 474.375C55.4559 472.583 55.461 470.792 55.4689 469C55.4608 468.158 55.4527 467.316 55.4443 466.449C55.5378 460.613 55.5378 460.613 57.9083 457.471C60.1729 455.879 61.2611 455.457 64.0001 455.5Z"
                                  fill="#E41F07"
                                />
                                <path
                                  d="M288 471.5C288.66 471.49 289.32 471.479 290 471.469C292.918 472.244 294.093 473.691 296 476C296.518 478.594 296.518 478.594 296.531 481.5C296.536 482.552 296.542 483.604 296.547 484.688C296.531 485.781 296.516 486.874 296.5 488C296.515 489.093 296.531 490.186 296.547 491.312C296.542 492.364 296.537 493.416 296.531 494.5C296.527 495.459 296.522 496.418 296.518 497.406C295.858 500.713 294.589 501.909 292 504C290 504.531 290 504.531 288 504.5C287.01 504.515 287.01 504.515 286 504.531C283.082 503.756 281.907 502.309 280 500C279.482 497.406 279.482 497.406 279.469 494.5C279.464 493.448 279.458 492.396 279.453 491.312C279.469 490.219 279.484 489.126 279.5 488C279.485 486.907 279.469 485.814 279.453 484.688C279.461 483.11 279.461 483.11 279.469 481.5C279.473 480.541 279.478 479.582 279.482 478.594C280.397 474.012 283.326 471.427 288 471.5Z"
                                  fill="#E41F07"
                                />
                              </svg>
                            </div>
                            <h5 className="card-title card-title-form">
                              Courier{" "}
                            </h5>
                          </div>
                        </div>
                        <div className="card-img-overlay p-0">
                          <img
                            src="/assets/img/courier.png"
                            alt="Cargo Freight Image"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              {selectedCard === "air" && (
                <>
                  <div className="d-flex mt-2 mb-5 form-heading">
                    <i className="fa-solid fa-plane"></i>
                    <h4>Air Quotation Form</h4>
                  </div>
                  <div className="row location-area">
                    <div className="col-md-5">
                      <div className="location-select">
                        <label className="form-label form-label-location">
                          Where are you shipping from?
                        </label>
                        <div className="row p-2">
                          <div className="col-md-3">
                            <div className=" icons-airport-form active">
                              <i className="fa-solid fa-plane"></i>
                              <p>Airport</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-warehouse"></i>
                              <p>Warehouse</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-building"></i>
                              <p>Business</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-shop"></i>
                              <p>Residential</p>
                            </div>
                          </div>
                        </div>
                        <div className="input-group mb-3">
                          <button
                            className="btn search-btn-popup"
                            type="button"
                            id="button-addon1"
                          >
                            <i className="fa-solid fa-plane"></i>
                          </button>
                          <input
                            type="text"
                            className="form-control input-search"
                            placeholder="Search location"
                            aria-label="Example text with button addon"
                            aria-describedby="button-addon1"
                          />
                        </div>
                        <div className="row mt-3 p-2">
                          <div className="col-md-4 mt-3">City</div>
                          <div className="col-md-8 mt-3 fw-bold">Delhi</div>
                          <div className="col-md-4 mt-3">Country</div>
                          <div className="col-md-8 mt-3 fw-bold">India</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 location-icon">
                      <div className="location-icon-distance">
                        <img src="/assets/img/distance.png" alt="" />
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="location-select">
                        <label className="form-label form-label-location">
                          Where are you shipping to?
                        </label>
                        <div className="row p-2">
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-plane"></i>
                              <p>Airport</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form active">
                              <i className="fa-solid fa-warehouse"></i>
                              <p>Warehouse</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-building"></i>
                              <p>Business</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-shop"></i>
                              <p>Residential</p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Address <span className="text-danger"></span>
                            </label>
                            <input
                              className="form-control form-control-sm mb-3"
                              type="text"
                              placeholder="Enter address"
                              name="origin_pincode"
                            />
                          </div>

                          <div className="col-md-6">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Country <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                          <div className="col-md-6">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              State <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                          <div className="col-md-6 mt-3">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              City <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>

                          <div className="col-md-6 mt-3">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Postal/Zip Code{" "}
                              <span className="text-danger"></span>
                            </label>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              placeholder="Enter Postal/Zip code"
                              name="origin_pincode"
                            />

                            <div>
                              <input
                                id="origin_pincode_notavailable"
                                type="checkbox"
                                className="me-1"
                              />
                              <label
                                for="basicpill-firstname-input"
                                className="form-label"
                                htmlFor="origin_pincode_notavailable"
                              >
                                {" "}
                                Not available
                              </label>

                              <i className="fa-solid fa-circle-info ms-1"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-section d-flex align-items-baseline">
                        <label>I am the</label>
                        <div className="radio-with-Icon">
                          <p className="radioOption-Item">
                            <input
                              type="radio"
                              name="BannerTypes"
                              id="BannerType1"
                              value="true"
                              className="ng-valid ng-dirty ng-touched ng-empty"
                              aria-invalid="false"
                            />
                            <label for="BannerType1">
                              <i className="fa fa-solid fa-file-import"></i>
                              Importer
                            </label>
                          </p>

                          <p className="radioOption-Item">
                            <input
                              type="radio"
                              name="BannerTypes"
                              id="BannerType2"
                              value="false"
                              className="ng-valid ng-dirty ng-touched ng-empty"
                              aria-invalid="false"
                            />
                            <label for="BannerType2">
                              <i className="fa fa-solid fa-file-export"></i>
                              Exporter
                            </label>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mt-3">
                        <div className="input_box_section">
                          <label
                            for="basicpill-firstname-input"
                            className="form-label"
                          >
                            INCO Term
                          </label>
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-select form-select-sm mb-3"
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Select Inco Term</option>
                            <option value="1">Micro</option>
                            <option value="2">Small</option>
                            <option value="3">Medium</option>
                          </select> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <form>
                    <div className="main_detail_form mt-4">
                      <div className="main-nav-det">
                        <h4>General information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Full Name <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              className="form-control form-control-sm"
                              placeholder="Enter Full Name"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Phone Number <span>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Enter Phone Number"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Email Id <span>*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              placeholder="Enter Email"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4>Pickup Information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Cargo ready on <span>*</span>
                            </label>
                            <div
                              className="custom-datepicker"
                              style={{ position: "relative" }}
                            >
                              <input
                                type="date"
                                className="form-control form-control-sm"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Requested Currency <span>*</span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Commodity Type <span>*</span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4>Cargo</h4>
                      </div>

                      <div className="row">
                        <div className="col-md-3">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Quantity <span>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Enter quantity"
                            />
                          </div>
                        </div>
                        <div className="col-md-9 d-flex justify-content-between">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Packaging <span>*</span>
                            </label>
                            <div className="packaging-options">
                              <button
                                type="button"
                                className="package-btn active"
                              >
                                {" "}
                                Pallet
                                <i className="check-icon fa-solid fa-check"></i>
                              </button>
                              <button type="button" className="package-btn">
                                {" "}
                                Drum
                              </button>
                              <button type="button" className="package-btn">
                                {" "}
                                Crate
                              </button>
                              <button type="button" className="package-btn">
                                {" "}
                                Cartoon
                              </button>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="bg-none add-package input_box_section"
                          >
                            <span className="mx-2">
                              <i className="fa-solid fa-plus"></i>
                            </span>
                          </button>
                        </div>
                        <div className="col-md-3 mt-2">
                          <div className=" ">
                            <label
                              htmlFor="weight"
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Unit weight
                              <span className="required"> *</span>
                            </label>
                            <div className="dimensions-input-container">
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="length"
                                  placeholder="Weight"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <select className="unit-select form-select">
                                <option value="cm">Kgs</option>
                                <option value="inches">Lbs</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Dimensions (L x W x H per box){" "}
                              <span className="required">*</span>
                            </label>
                            <div className="dimensions-input-container">
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="length"
                                  placeholder="Length"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="width"
                                  placeholder="Width"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="height"
                                  placeholder="Height"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <select className="unit-select form-select">
                                <option value="cm">Cm</option>
                                <option value="inches">Inches</option>
                              </select>
                            </div>
                            <a href="#" className="volume-text">
                              Enter Volume
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4>Additionals</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault1"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault1"
                            >
                              Origin charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault2"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault2"
                            >
                              Freight charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault3"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault3"
                            >
                              Destination charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault4"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault4"
                            >
                              Refrigerated{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault5"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault5"
                            >
                              Customs clearance origin{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault6"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault6"
                            >
                              Hazardous cargo{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault7"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault7"
                            >
                              Insurance{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault8"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault8"
                            >
                              Overweight{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault9"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault9"
                            >
                              Stackable{" "}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          className="btn btn-danger me-md-2"
                          type="button"
                        >
                          Create Quotation
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}

              {selectedCard === "ocean" && (
                <>
                  <div className="d-flex mt-2 mb-3 form-heading">
                    <i className="fa-solid fa-anchor"></i>
                    <h4>Ocean Quotation Form</h4>
                  </div>

                  <div className="input-section d-flex align-items-baseline mb-5">
                    <label>A full or partial load?</label>
                    <div className="radio-with-Icon">
                      <p className="radioOption-Item">
                        <input
                          type="radio"
                          name="BannerTypes"
                          id="BannerType1"
                          value="true"
                          className="ng-valid ng-dirty ng-touched ng-empty"
                          aria-invalid="false"
                        />
                        <label for="BannerType1">Full (FCL)</label>
                      </p>

                      <p className="radioOption-Item">
                        <input
                          type="radio"
                          name="BannerTypes"
                          id="BannerType2"
                          value="false"
                          className="ng-valid ng-dirty ng-touched ng-empty"
                          aria-invalid="false"
                        />
                        <label for="BannerType2">Partial (LCL)</label>
                      </p>
                    </div>
                  </div>
                  <div className="row location-area">
                    <div className="col-md-5">
                      <div className="location-select">
                        <label className="form-label form-label-location">
                          Where are you shipping from?
                        </label>
                        <div className="row p-2">
                          <div className="col-md-3">
                            <div className=" icons-airport-form active">
                              <i className="fa-solid fa-anchor"></i>
                              <p>Port</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-warehouse"></i>
                              <p>Warehouse</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-building"></i>
                              <p>Business</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-shop"></i>
                              <p>Residential</p>
                            </div>
                          </div>
                        </div>
                        <div className="input-group mb-3">
                          <button
                            className="btn search-btn-popup"
                            type="button"
                            id="button-addon1"
                          >
                            <i className="fa-solid fa-anchor"></i>
                          </button>
                          <input
                            type="text"
                            className="form-control input-search"
                            placeholder="Search location"
                            aria-label="Example text with button addon"
                            aria-describedby="button-addon1"
                          />
                        </div>
                        <div className="row mt-3 p-2">
                          <div className="col-md-4 mt-3">City</div>
                          <div className="col-md-8 mt-3 fw-bold">Delhi</div>
                          <div className="col-md-4 mt-3">Country</div>
                          <div className="col-md-8 mt-3 fw-bold">India</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 location-icon">
                      <div className="location-icon-distance">
                        <img src="/assets/img/distance.png" alt="" />
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="location-select">
                        <label className="form-label form-label-location">
                          Where are you shipping to?
                        </label>
                        <div className="row p-2">
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-anchor"></i>
                              <p>Port</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form active">
                              <i className="fa-solid fa-warehouse"></i>
                              <p>Warehouse</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-building"></i>
                              <p>Business</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-shop"></i>
                              <p>Residential</p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Address <span className="text-danger"></span>
                            </label>
                            <input
                              className="form-control form-control-sm mb-3"
                              type="text"
                              placeholder="Enter address"
                              name="origin_pincode"
                            />
                          </div>

                          <div className="col-md-6">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Country <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                          <div className="col-md-6">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              State <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                          <div className="col-md-6 mt-2">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              City <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>

                          <div className="col-md-6 mt-2">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Postal/Zip Code{" "}
                              <span className="text-danger"></span>
                            </label>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              placeholder="Enter Postal/Zip code"
                              name="origin_pincode"
                            />

                            <div>
                              <input
                                id="origin_pincode_notavailable"
                                type="checkbox"
                                className="me-1"
                              />
                              <label
                                for="basicpill-firstname-input"
                                className="form-label"
                                htmlFor="origin_pincode_notavailable"
                              >
                                {" "}
                                Not available
                              </label>

                              <i className="fa-solid fa-circle-info ms-1"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-section d-flex align-items-baseline">
                        <label>I am the</label>
                        <div className="radio-with-Icon">
                          <p className="radioOption-Item">
                            <input
                              type="radio"
                              name="BannerTypes"
                              id="BannerType1"
                              value="true"
                              className="ng-valid ng-dirty ng-touched ng-empty"
                              aria-invalid="false"
                            />
                            <label for="BannerType1">
                              <i className="fa fa-solid fa-file-import"></i>
                              Importer
                            </label>
                          </p>

                          <p className="radioOption-Item">
                            <input
                              type="radio"
                              name="BannerTypes"
                              id="BannerType2"
                              value="false"
                              className="ng-valid ng-dirty ng-touched ng-empty"
                              aria-invalid="false"
                            />
                            <label for="BannerType2">
                              <i className="fa fa-solid fa-file-export"></i>
                              Exporter
                            </label>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mt-3">
                        <div className="input_box_section">
                          <label
                            for="basicpill-firstname-input"
                            className="form-label"
                          >
                            INCO Term
                          </label>
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <form>
                    <div className="main_detail_form mt-4">
                      <div className="main-nav-det">
                        <h4>General information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Full Name <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              className="form-control form-control-sm"
                              placeholder="Enter Full Name"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Phone Number <span>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Enter Phone Number"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Email Id <span>*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              placeholder="Enter Email"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4>Pickup Information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Cargo ready on <span>*</span>
                            </label>
                            <div
                              className="custom-datepicker"
                              style={{ position: "relative" }}
                            >
                              <input
                                type="date"
                                className="form-control form-control-sm"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Requested Currency <span>*</span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Commodity Type <span>*</span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4>Cargo</h4>
                      </div>

                      {/* FCL data */}

                      <div>
                        <>
                          <div className="row">
                            <div className="col-md-6 mt-2">
                              <div className=" ">
                                <label
                                  htmlFor="weight"
                                  for="basicpill-firstname-input"
                                  className="form-label"
                                >
                                  Quantity & Container <span>*</span>
                                </label>
                                <div className="dimensions-input-container">
                                  <div className="input-wrapper">
                                    <input
                                      type="number"
                                      id="length"
                                      placeholder="Quantity"
                                      className="dimension-input form-control form-control-sm"
                                    />
                                  </div>
                                  <select className="unit-select form-select form-select-sm dimension-input-5">
                                    <option value="" disabled>
                                      Container Size
                                    </option>
                                    <option value="cm">20' Container</option>
                                    <option value="inches">
                                      40' Container
                                    </option>
                                    <option value="inches">
                                      40'HC Container
                                    </option>
                                    <option value="inches">
                                      45' Container
                                    </option>
                                    <option value="inches">
                                      45' HC Container
                                    </option>
                                    <option value="inches">
                                      48' Container
                                    </option>
                                    <option value="inches">53' Trailer</option>
                                  </select>
                                  <select className="unit-select form-select form-select-sm dimension-input-4">
                                    <option value="" disabled>
                                      Container Type
                                    </option>
                                    <option value="cm">Dry</option>
                                    <option value="inches">Reefer</option>
                                    <option value="inches">Open Top</option>
                                    <option value="inches">Flat Rack</option>
                                    {/* <option value="inches">
                                      Non-Operating Reefer
                                    </option>
                                    <option value="inches">Tank</option>
                                    <option value="inches">Garment</option>
                                    <option value="inches">Platform</option>
                                    <option value="inches">Trailer</option>
                                    <option value="inches">All Types</option> */}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-3 mt-2">
                              <div className=" ">
                                <label
                                  htmlFor="weight"
                                  for="basicpill-firstname-input"
                                  className="form-label"
                                >
                                  Unit weight (Optional)
                                </label>
                                <div className="dimensions-input-container">
                                  <div className="input-wrapper">
                                    <input
                                      type="number"
                                      id="length"
                                      placeholder="Weight"
                                      className="dimension-input form-control form-control-sm"
                                    />
                                  </div>
                                  <select className="unit-select form-select form-select-sm">
                                    <option value="cm">Kgs</option>
                                    <option value="inches">Lbs</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      </div>

                      {/* LCL data */}

                      {/* <div className="row">
                        <div className="col-md-3">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Quantity <span>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Enter quantity"
                            />
                          </div>
                        </div>
                        <div className="col-md-9 d-flex justify-content-between">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Packaging <span>*</span>
                            </label>
                            <div className="packaging-options">
                              <button
                                type="button"
                                className="package-btn active"
                              >
                                {" "}
                                Pallet
                                <i className="check-icon fa-solid fa-check"></i>
                              </button>
                              <button type="button" className="package-btn">
                                {" "}
                                Drum
                              </button>
                              <button type="button" className="package-btn">
                                {" "}
                                Crate
                              </button>
                              <button type="button" className="package-btn">
                                {" "}
                                Cartoon
                              </button>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="bg-none add-package input_box_section"
                          >
                            <span className="mx-2">
                              <i className="fa-solid fa-plus"></i>
                            </span>
                          </button>
                        </div>
                        <div className="col-md-3 mt-2">
                          <div className=" ">
                            <label
                              htmlFor="weight"
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Unit weight
                              <span className="required"> *</span>
                            </label>
                            <div className="dimensions-input-container">
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="length"
                                  placeholder="Weight"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <select className="unit-select form-select">
                                <option value="cm">Kgs</option>
                                <option value="inches">Lbs</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="  ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Dimensions (L x W x H per box){" "}
                              <span className="required">*</span>
                            </label>
                            <div className="dimensions-input-container">
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="length"
                                  placeholder="Length"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="width"
                                  placeholder="Width"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="height"
                                  placeholder="Height"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <select className="unit-select form-select">
                                <option value="cm">Cm</option>
                                <option value="inches">Inches</option>
                              </select>
                            </div>
                            <a href="#" className="volume-text">
                              Enter Volume
                            </a>
                          </div>
                        </div>
                      </div> */}

                      <div className="main-nav-det">
                        <h4>Additionals</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault1"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault1"
                            >
                              Origin charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault2"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault2"
                            >
                              Freight charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault3"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault3"
                            >
                              Destination charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault4"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault4"
                            >
                              Refrigerated{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault5"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault5"
                            >
                              Customs clearance origin{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault6"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault6"
                            >
                              Hazardous cargo{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault7"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault7"
                            >
                              Insurance{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault8"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault8"
                            >
                              Overweight{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault9"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault9"
                            >
                              Stackable{" "}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          className="btn btn-danger me-md-2"
                          type="button"
                        >
                          Create Quotation
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}

              {selectedCard === "truck" && (
                <>
                  <div className="d-flex mt-2 mb-3 form-heading">
                    <i className="fa-solid fa-truck"></i>
                    <h4>Truck Quotation Form</h4>
                  </div>

                  <div className="input-section d-flex align-items-baseline mb-5">
                    <label>A full or partial load?</label>
                    <div className="radio-with-Icon">
                      <p className="radioOption-Item">
                        <input
                          type="radio"
                          name="BannerTypes"
                          id="BannerType1"
                          value="true"
                          className="ng-valid ng-dirty ng-touched ng-empty"
                          aria-invalid="false"
                        />
                        <label for="BannerType1">Full (FCL)</label>
                      </p>

                      <p className="radioOption-Item">
                        <input
                          type="radio"
                          name="BannerTypes"
                          id="BannerType2"
                          value="false"
                          className="ng-valid ng-dirty ng-touched ng-empty"
                          aria-invalid="false"
                        />
                        <label for="BannerType2">Partial (LCL)</label>
                      </p>
                    </div>
                  </div>
                  <div className="row location-area">
                    <div className="col-md-5">
                      <div className="location-select">
                        <label className="form-label form-label-location">
                          Where are you shipping from?
                        </label>
                        <div className="row p-2">
                          <div className="col-md-3">
                            <div className=" icons-airport-form active">
                              <i className="fa-solid fa-bridge"></i>
                              <p>Terminal</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-warehouse"></i>
                              <p>Warehouse</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-building"></i>
                              <p>Business</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-shop"></i>
                              <p>Residential</p>
                            </div>
                          </div>
                        </div>
                        <div className="input-group mb-3">
                          <button
                            className="btn search-btn-popup"
                            type="button"
                            id="button-addon1"
                          >
                            <i className="fa-solid fa-bridge"></i>
                          </button>
                          <input
                            type="text"
                            className="form-control input-search"
                            placeholder="Search location"
                            aria-label="Example text with button addon"
                            aria-describedby="button-addon1"
                          />
                        </div>
                        <div className="row mt-3 p-2">
                          <div className="col-md-4 mt-3">City</div>
                          <div className="col-md-8 mt-3 fw-bold">Delhi</div>
                          <div className="col-md-4 mt-3">Country</div>
                          <div className="col-md-8 mt-3 fw-bold">India</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 location-icon">
                      <div className="location-icon-distance">
                        <img src="/assets/img/distance.png" alt="" />
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="location-select">
                        <label className="form-label form-label-location">
                          Where are you shipping to?
                        </label>
                        <div className="row p-2">
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-bridge"></i>
                              <p>Terminal</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form active">
                              <i className="fa-solid fa-warehouse"></i>
                              <p>Warehouse</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-building"></i>
                              <p>Business</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className=" icons-airport-form">
                              <i className="fa-solid fa-shop"></i>
                              <p>Residential</p>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Address <span className="text-danger"></span>
                            </label>
                            <input
                              className="form-control form-control-sm mb-3"
                              type="text"
                              placeholder="Enter address"
                              name="origin_pincode"
                            />
                          </div>

                          <div className="col-md-6">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Country <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                          <div className="col-md-6">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              State <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                          <div className="col-md-6 mt-2">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              City <span className="text-danger"></span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>

                          <div className="col-md-6 mt-2">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Postal/Zip Code{" "}
                              <span className="text-danger"></span>
                            </label>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              placeholder="Enter Postal/Zip code"
                              name="origin_pincode"
                            />

                            <div>
                              <input
                                id="origin_pincode_notavailable"
                                type="checkbox"
                                className="me-1"
                              />
                              <label
                                for="basicpill-firstname-input"
                                className="form-label"
                                htmlFor="origin_pincode_notavailable"
                              >
                                {" "}
                                Not available
                              </label>

                              <i className="fa-solid fa-circle-info ms-1"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-section d-flex align-items-baseline">
                        <label>I am the</label>
                        <div className="radio-with-Icon">
                          <p className="radioOption-Item">
                            <input
                              type="radio"
                              name="BannerTypes"
                              id="BannerType1"
                              value="true"
                              className="ng-valid ng-dirty ng-touched ng-empty"
                              aria-invalid="false"
                            />
                            <label for="BannerType1">
                              <i className="fa fa-solid fa-file-import"></i>
                              Importer
                            </label>
                          </p>

                          <p className="radioOption-Item">
                            <input
                              type="radio"
                              name="BannerTypes"
                              id="BannerType2"
                              value="false"
                              className="ng-valid ng-dirty ng-touched ng-empty"
                              aria-invalid="false"
                            />
                            <label for="BannerType2">
                              <i className="fa fa-solid fa-file-export"></i>
                              Exporter
                            </label>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mt-3">
                        <div className="input_box_section">
                          <label
                            for="basicpill-firstname-input"
                            className="form-label"
                          >
                            INCO Term
                          </label>
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <form>
                    <div className="main_detail_form mt-4">
                      <div className="main-nav-det">
                        <h4>General information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Full Name <span>*</span>
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              className="form-control form-control-sm"
                              placeholder="Enter Full Name"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Phone Number <span>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Enter Phone Number"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Email Id <span>*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control form-control-sm"
                              placeholder="Enter Email"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4>Pickup Information</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Cargo ready on <span>*</span>
                            </label>
                            <div
                              className="custom-datepicker"
                              style={{ position: "relative" }}
                            >
                              <input
                                type="date"
                                className="form-control form-control-sm"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Requested Currency <span>*</span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="input_box_section">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Commodity Type <span>*</span>
                            </label>
                            <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                          </div>
                        </div>
                      </div>
                      <div className="main-nav-det">
                        <h4>Cargo</h4>
                      </div>

                      {/* FCL data */}

                      {/* <div>
                      <>
                        <div className="row">
                          <div className="col-md-4 mt-2">
                            <div className=" ">
                              <label
                                htmlFor="weight"
                                for="basicpill-firstname-input"
                                className="form-label"
                              >
                                Quantity & Container <span>*</span>
                              </label>
                              <div className="dimensions-input-container">
                                <div className="input-wrapper">
                                  <input
                                    type="number"
                                    id="length"
                                    placeholder="Quantity"
                                    className="dimension-input form-control form-control-sm"
                                  />
                                </div>
                                <select className="unit-select form-select form-select-sm">
                                  <option value="" disabled>
                                    Container Size
                                  </option>
                                  <option value="cm">20' Container</option>
                                  <option value="inches">
                                    40' Container
                                  </option>
                                  <option value="inches">
                                    40'HC Container
                                  </option>
                                  <option value="inches">
                                    45' Container
                                  </option>
                                  <option value="inches">
                                    45' HC Container
                                  </option>
                                  <option value="inches">
                                    48' Container
                                  </option>
                                  <option value="inches">53' Trailer</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          

                          <div className="col-md-3 mt-2">
                            <div className=" ">
                              <label
                                htmlFor="weight"
                                for="basicpill-firstname-input"
                                className="form-label"
                              >
                                Unit weight (Optional)
                              </label>
                              <div className="dimensions-input-container">
                                <div className="input-wrapper">
                                  <input
                                    type="number"
                                    id="length"
                                    placeholder="Weight"
                                    className="dimension-input form-control form-control-sm"
                                  />
                                </div>
                                <select className="unit-select form-select form-select-sm">
                                  <option value="cm">Kgs</option>
                                  <option value="inches">Lbs</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </div> */}

                      {/* LCL data */}

                      <div className="row">
                        <div className="col-md-3">
                          <div className="input_box_section ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Quantity <span>*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Enter quantity"
                            />
                          </div>
                        </div>
                        <div className="col-md-9 d-flex justify-content-between">
                          <div className="col-md-6">
                            <div className="input_box_section">
                              <label
                                for="basicpill-firstname-input"
                                className="form-label"
                              >
                                Packaging <span>*</span>
                              </label>
                              <Select
                            className="basic-single"
                            classNamePrefix="select"
                            styles={customStyles}
                          />
                            </div>
                          </div>
                          <button
                            type="button"
                            className="bg-none add-package input_box_section"
                          >
                            <span className="mx-2">
                              <i className="fa-solid fa-plus"></i>
                            </span>
                          </button>
                        </div>
                        <div className="col-md-3 mt-2">
                          <div className=" ">
                            <label
                              htmlFor="weight"
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Unit weight
                              <span className="required"> *</span>
                            </label>
                            <div className="dimensions-input-container">
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="length"
                                  placeholder="Weight"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <select className="unit-select form-select">
                                <option value="cm">Kgs</option>
                                <option value="inches">Lbs</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 mt-2">
                          <div className="  ">
                            <label
                              for="basicpill-firstname-input"
                              className="form-label"
                            >
                              Dimensions (L x W x H per box){" "}
                              <span className="required">*</span>
                            </label>
                            <div className="dimensions-input-container">
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="length"
                                  placeholder="Length"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="width"
                                  placeholder="Width"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <div className="input-wrapper">
                                <input
                                  type="number"
                                  id="height"
                                  placeholder="Height"
                                  className="dimension-input form-control form-control-sm"
                                />
                              </div>
                              <select className="unit-select form-select">
                                <option value="cm">Cm</option>
                                <option value="inches">Inches</option>
                              </select>
                            </div>
                            <a href="#" className="volume-text">
                              Enter Volume
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="main-nav-det">
                        <h4>Additionals</h4>
                      </div>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault1"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault1"
                            >
                              Origin charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault2"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault2"
                            >
                              Freight charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault3"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault3"
                            >
                              Destination charges{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault4"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault4"
                            >
                              Refrigerated{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault5"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault5"
                            >
                              Customs clearance origin{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault6"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault6"
                            >
                              Hazardous cargo{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault7"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault7"
                            >
                              Insurance{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault8"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault8"
                            >
                              Overweight{" "}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input form-switch-add"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckDefault9"
                            />
                            <label
                              className="form-check-label"
                              for="flexSwitchCheckDefault9"
                            >
                              Stackable{" "}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button
                          className="btn btn-danger me-md-2"
                          type="button"
                        >
                          Create Quotation
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}

              {selectedCard === "courier" && (
                <div className="d-flex mt-2 mb-3 form-heading">
                <i className="fa-solid fa-truck"></i>
                <h4>Courier Quotation Form</h4>
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QueryList;
